import { render, staticRenderFns } from "./drones.vue?vue&type=template&id=d8ffadd0&lang=html"
import script from "./drones.vue?vue&type=script&lang=js"
export * from "./drones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports